import styled, { css } from 'styled-components';
import { Tabs as AntdTabs } from 'antd';

import { TabSize } from './types';

export const Tabs = styled(AntdTabs)<{ $size: TabSize }>`
  color: ${({ theme }) => theme.colors.grey70};

  &.ant-tabs-top > .ant-tabs-nav::before {
    border-bottom: none;
  }

  .ant-tabs-nav .ant-tabs-nav-operations {
    display: none !important;
  }

  & > .ant-tabs-nav {
    margin-bottom: 0;
    width: 100%;
  }
  & .ant-tabs-tab {
    flex: 1;
    font-weight: 600;
    justify-content: center;
    border-bottom-color: transparent;
    ${({ $size }) =>
      $size === 'large'
        ? css`
            padding: 21px 70px;
            font-size: 24px;
          `
        : css`
            font-size: 15px;
          `}

    &.ant-tabs-tab-active .ant-tabs-tab-btn {
      color: ${({ theme }) => theme.colors.green100};
    }
  }
`;

export const TabPane = styled(Tabs.TabPane)``;
